import type { OneDriveAttachmentRef } from '@/integration/types.js';
import type { OneDriveItem } from '@/lib/api/onedrive.js';

/** Stable identity of one personal OneDrive item inside its connected scope. */
export function oneDriveRefKey(
  ref: Pick<OneDriveAttachmentRef, 'scope_id' | 'item_id'>,
): string {
  return `${ref.scope_id}\u0000${ref.item_id}`;
}

/** Build the exact live-reference descriptor accepted by the conversation service. */
export function oneDriveAttachmentRef(
  scopeId: string,
  item: OneDriveItem,
): OneDriveAttachmentRef {
  return {
    source: 'onedrive',
    scope_id: scopeId,
    item_id: item.itemId,
    name: item.name,
    content_type: item.contentType,
    size: item.size,
  };
}
